import { multi } from "consts/onboarding";
import { date, FilterVariant } from "consts/filters";
import { useTypedSelector } from "hooks";
import { selectOnboardingApplicationStatusOptions } from "features/general/selectors";

export const useApplicationTableResourceFilters = () => {
    const onboardingApplicationStatusOptions = useTypedSelector(selectOnboardingApplicationStatusOptions);

    return {
        filterTypes: new Map<FilterVariant, string[]>([
            [FilterVariant.DateRange, date],
            [FilterVariant.MultiOption, multi]
        ]),
        filtersModelOverrides: {
            TransactionStatus: onboardingApplicationStatusOptions
        }
    };
};
